import React from 'react';

import { useEditorTabStateSelector } from 'src/editor/editor-tab-state-registry';
import { useEditingHooks } from 'src/editor/helpers/useEditingHooks';
import { ClientTransforms } from 'src/editor/transforms';
import { useCurrentUserId } from 'src/gql';
import { useAuthorizedTransforms } from 'src/hooks';

import { GenericColorSelect } from '../shared/GenericColorSelect';

export const TableBorderColorSelect = React.memo(function TableBorderColorSelect(): JSX.Element {
  const { AuthorizedTransforms } = useAuthorizedTransforms();
  const { authorId, editingMode, editor, editorLoading } = useEditingHooks();

  const activeBorderColor = useEditorTabStateSelector(
    state => state.derived.tableProperties.activeBorderColor
  );
  const currentUserId = useCurrentUserId();

  const selectColor = (color: string | null) => {
    if (!authorId || !editingMode || !currentUserId) return;

    AuthorizedTransforms.setSelectedTableCellsBorder(editor, {
      authorId: currentUserId,
      borderProps: { color: color ?? undefined },
      editingMode,
    });

    ClientTransforms.focus(editor);
  };

  return (
    <GenericColorSelect
      color={activeBorderColor ?? null}
      editorLoading={editorLoading}
      hasTransparentOption={true}
      iconType="line"
      tooltipTitle="Border color"
      onSelectColor={selectColor}
    />
  );
});
